import { Col, message, Row, Space, Form as FormInitial } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  TextAreaItem,
  ErrorItem,
} from "../../../../Components/Items";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

class SolicitarComplemento extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    nombreProveedor: "",
    nombreEmpresa: "",
    montoTexto: "",
    facturasTexto: [],
    mensaje: "",
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarDatos();
    }
  }
  async consultarDatos() {
    this.setState({ loading: true });
    await axios
      .post(
        "pagos/datosSolicitudComplemento",
        { pagoId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            nombreProveedor: res.data.nombreProveedor || "",
            nombreEmpresa: res.data.nombreEmpresa || "",
            montoTexto: res.data.montoTexto || "",
            facturasTexto: res.data.facturasTexto || [],
          });
          if (res.data.correosEnvio?.length > 0) {
            this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio });
          }
        } else {
          message.error("No se pudieron obtener los datos del pago");
        }
      })
      .catch(() => {
        message.error("Error al obtener los datos del pago");
      });
    this.setState({ loading: false });
  }
  renderVistaPrevia() {
    const { nombreProveedor, nombreEmpresa, montoTexto, facturasTexto, mensaje } = this.state;
    return (
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: 8,
          overflow: "hidden",
          marginBottom: 16,
        }}
      >
        <div style={{ background: "#F7F7F7", textAlign: "center", padding: "10px 16px", fontWeight: "bold", color: "#333", borderBottom: "1px solid #eee" }}>
          Vista previa del correo
        </div>
        <div style={{ padding: "16px 20px", color: "#555", lineHeight: 1.6, fontSize: 13 }}>
          <p style={{ margin: "8px 0" }}>Estimado/a {nombreProveedor || "proveedor"},</p>
          <p style={{ margin: "8px 0" }}>
            Por medio del presente, <strong>{nombreEmpresa || "la empresa"}</strong> le solicita de la manera más atenta el envío del <strong>complemento de pago (REP)</strong> correspondiente al siguiente pago:
          </p>
          <div style={{ background: "#F7F7F7", borderRadius: 8, padding: "12px 16px", margin: "12px 0", textAlign: "left" }}>
            <p style={{ margin: "6px 0" }}><strong>Monto del pago:</strong> {montoTexto || "-"}</p>
            {facturasTexto.map((t, i) => (
              <p key={i} style={{ margin: "6px 0" }}>{t}</p>
            ))}
          </div>
          {mensaje ? <p style={{ margin: "8px 0" }}>{mensaje}</p> : null}
          <p style={{ margin: "8px 0" }}>Agradecemos de antemano su atención y quedamos a la espera del comprobante.</p>
        </div>
      </div>
    );
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (!values?.correosEnvio?.length > 0) {
      return message.info("Proporcione al menos un correo de envío");
    }
    this.setState({ loading: true });
    axios
      .post(
        "pagos/solicitarComplemento",
        {
          correosEnvio: values.correosEnvio,
          mensaje: values.mensaje,
          pagoId: this.props.id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Solicitud enviada al proveedor");
          this.cerrar();
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo enviar la solicitud");
        } else {
          message.error("Sucedió un error y no se pudo enviar");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Sucedió un error y no se pudo enviar");
      });
  }
  cerrar() {
    this.formRef.current.resetFields();
    this.setState({ nombreProveedor: "", nombreEmpresa: "", montoTexto: "", facturasTexto: [], mensaje: "" });
    this.props.cerrarSolicitarComplemento();
  }
  render() {
    return (
      <ModalItem
        title="Solicitar Complemento de Pago"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrar.bind(this)}
        paddingTop
      >
        {this.renderVistaPrevia()}
        <Form
          ref={this.formRef}
          name="solicitarComplemento"
          layout
          width={700}
          onCancel={this.cerrar.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <FormItem name="mensaje" label="Nota" margin pattern>
            <TextAreaItem
              rows={3}
              placeholder="Mensaje adicional (opcional)"
              onChange={(e) => this.setState({ mensaje: e.target.value })}
            />
          </FormItem>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem type="primary" htmlType="submit">
                Enviar Solicitud
              </ButtonItem>
              <ButtonItem type="primary" danger onClick={this.cerrar.bind(this)}>
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(SolicitarComplemento);
